import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ISectionProps } from "../../../../@types/Patient";
import { ChevronDown } from "../../../../assets/icons/ChevronDown";
import { ChevronUp } from "../../../../assets/icons/ChevronUp";
import { CustomIconButton } from "../../../../components/CustomIconButton";
import { useInfiniteJournals } from "../../../../hooks/queries/journals";
import useIsMobile from "../../../../hooks/useIsMobile";
import { PageTitle } from "../../../../layout/components/PageTitle";
import { PatientJournalsTable } from "../PatientJournalsTable";
import { NewDataCOntainer, TitleContainer } from "./JournalSections.styles";

export function JournalsSection({
  patient,
  updateColapsedSections,
  collapsedSection,
}: ISectionProps) {
  const { t } = useTranslation();

  const { isMobile } = useIsMobile();
  const highlightedRows = [false];

  const [showNewData, setShowNewData] = useState<boolean>(false);

  const {
    journals,
    isError,
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    refetch,
    isRefetching,
  } = useInfiniteJournals(patient.id);

  const handleRefreshTable = () => {
    refetch();
  };

  // Check for new data when section is collapsed
  useEffect(() => {
    if (
      collapsedSection.value === true &&
      !isFetching &&
      !isRefetching &&
      journals.length > 0
    ) {
      const mostRecentJournalDate = journals[0]?.date
        ? dayjs(journals[0].date)
        : dayjs("2000-01-01");
      const collapsedDate = dayjs(collapsedSection.collapsedDate);

      if (mostRecentJournalDate > collapsedDate) {
        setShowNewData(true);
      }
    }
  }, [journals, collapsedSection, isFetching, isRefetching]);

  const handleCollapseSection = () => {
    if (collapsedSection.value === true) {
      setShowNewData(false);
    }
    updateColapsedSections("journalsSection");
  };

  return (
    <>
      {!isMobile && (
        <TitleContainer>
          <PageTitle>{t("patientPage_sections_journal")}</PageTitle>
          {showNewData && (
            <NewDataCOntainer>
              {t("patientPage_sections_newData")}
            </NewDataCOntainer>
          )}
          <CustomIconButton
            style={{ marginLeft: "2px" }}
            onClick={handleCollapseSection}
          >
            {collapsedSection.value ? <ChevronUp /> : <ChevronDown />}
          </CustomIconButton>
        </TitleContainer>
      )}
      <div
        style={{
          height: collapsedSection.value ? "0" : "",
          overflow: collapsedSection.value ? "hidden" : "",
        }}
      >
        <PatientJournalsTable
          isLoading={isFetching && !isRefetching && !isFetchingNextPage}
          isError={isError}
          content={journals}
          highlightedRows={highlightedRows}
          refreshTable={handleRefreshTable}
          useInfiniteScroll
          hasNextPage={hasNextPage}
          isFetchingNextPage={isFetchingNextPage}
          fetchNextPage={fetchNextPage}
        />
      </div>
    </>
  );
}
